import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-onboarding-verificacao',
    templateUrl: './onboarding-verificacao.component.html',
    styleUrls: ['./onboarding-verificacao.component.sass']
})
export class OnboardingVerificacaoComponent implements OnInit {

    constructor() { }

    ngOnInit() {}

}
